import { TvvBesteldeRoute, TvvStandaardRoute } from "@/entities/tvv";
import { createContext, useContext } from "react";

export type TvvMode = "overzicht" | "selecteren" | "bestellen" | "zoeken";

type BestelTVVRoutesContext = {
    mode: TvvMode;
    setMode: (mode: TvvMode) => void;

    besteldeRoutes: TvvBesteldeRoute[];
    availableRoutes: TvvStandaardRoute[];
    selectedRoutes: TvvStandaardRoute[];

    toggleSelectedRoute: (routeId: number) => void;
    makeRouteAvailable: (route: TvvStandaardRoute, select: boolean, replaceId?: number) => void;
    clearSelectedRoutes: () => void;
    isSelected: (routeId: number) => boolean;
    isAlreadyAdded: (routeId: number) => boolean;
    isAlreadyBesteld: (routeId: number) => boolean;
};

export const BestelTVVRoutesContext = createContext<BestelTVVRoutesContext | null>(null);

export function useBestelTVVRoutes() {
    const context = useContext(BestelTVVRoutesContext);

    if (!context) {
        throw new Error("useBestelTVVRoutes must be used within the BestelTVVRoutesContext");
    }
    return context;
}
